var _g, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "100 100",
    id: "banana"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,30 C115,5 160,50 145,100 C130,150 90,150 75,100 C60,50 85,5 100,30 Z",
    fill: "#FFE135",
    stroke: "#E0A106",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 65,
    r: 1.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 65,
    r: 1.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,70 Q100,75 105,70",
    stroke: "black",
    strokeWidth: 0.8,
    fill: "none",
    strokeLinecap: "round"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes spin {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    #banana {\n      animation: spin 2s linear infinite;\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fc6f112662b0d452c7360ff7a0296032.svg";
export { ForwardRef as ReactComponent };